import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Avatar from '@mui/material/Avatar';
// import List, {
//   ListSubheader, 
//   ListItem, 
//   ListItemAvatar, 
//   ListItemText, 
//   ListItemSecondaryAction 
// } from '@mui/material/List';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
//import DeleteIcon from '@mui/icons-material/Delete';
//import SvgIcon from '@mui/material/SvgIcon';
import {cyan} from '@mui/material/colors';
//import Wallpaper from '@mui/icons-material/Wallpaper';
import moment from 'moment';
import {bizpost} from '../../ajax';
//import Preview from './Preview';
//import StarIcon from './star.svg';
import apply from '../icons/receipt.svg';
import SearchPreview from './SearchPreview';
import { Box, ListItemButton } from '@mui/material';

//<SvgIcon component={StarIcon} inheritViewBox />

const s:any = {
  paper: {
    backgroundColor: 'white',
    minHeight: 400,
    //overflow: 'scroll',
  },
  preview: {
    //height: 95,
    padding: '5px 15px 0 15px'
  },
  header: {
    fontSize: 24,
    fontWeight: 'typography.fontWeightLight',
    color: 'white',
    backgroundColor: cyan['600'],
    padding: 10,
  },
  nodata: {
    height:'100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
  // subheader: {
  //   fontSize: 24,
  //   fontWeight: 'typography.fontWeightLight',
  //   //backgroundColor: cyan['600'],
  //   color: white
  // }
};

class SearchResult extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      count:0,
      recid:0,
      reference:'',
      record:{rst:'PENDING',info:[{title:'Date',value:'2020-02-01'},{title:'Type',value:'1PHASE'}]},
      preview:false,
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.page !== nextProps.page) {
  //       this.setState({page: nextProps.page});
  //   }
  // }

  formatDate = (stamp:any) => {
    return moment(stamp,'YYYY-MM-DD HH:mm:ss.SSSSSS').format('DD-MMM HH:mm');
  }

  formatMoney = (currency:any,money:any) => {
    //.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    const cur = (currency)?`${currency} `:'';
    return (!!+money)?`${cur}${(+money).toFixed(2)}`:money;
  }

  formatMeta = (meta:any[]) => meta.reduce((acc:any,rec:any)=>({...acc,[rec.shc]:rec}),{});

  preview = (rfn:any) => async(ev:any) => {
    try{
      const baseparams = {s:'register',a:'find',rfn};
      const response = await bizpost(baseparams);
      console.log('reg resp',response);
      const {sd} = response;
      const record = sd[0];
      this.setState({record,preview:true,reference:rfn});
    }
    catch(error){
      console.log('preview error',error);
    } 
    //this.setState({preview:true,recid:rid});
  }

  onPreview = (item:any) => {
    this.setState({preview:true,record:item});
  }

  closePreview = () => {
    this.setState({preview:false});
  }

  render() {
    const {query,searchres:data,searchmeta:meta,classes} = this.props;
    const {preview,record} = this.state;
    //rid,dcd,sno,ssn,man,mmc,mac,mcc,bno,msc
    //{rid: 2, txd: '2024-08-31T21:50:38.044868', cmc: 'testing', ttc: 'COMMISSION', amt: 100}
    const title = 'Search Results';
    const me = this.formatMeta(meta);
    console.log('formated meta:',me);
    return (
      <Paper sx={{...s.paper}}>
        <Box sx={{...s.header}}>{title}</Box>
        {data.length>0?
        <Box sx={{...s.preview}}>
        <SearchPreview open={preview} query={query} result={data} record={record} meta={me} onClose={this.closePreview} />
        <List>
          {data.map((item:any,idx:number) =>
            <Box key={item.rid}>
              <ListItem secondaryAction = {
                <IconButton aria-label="View" onClick={()=>{this.onPreview(item)}}>
                    <MoreVertIcon color="action" />
                  </IconButton>
              }>
                <ListItemButton>
                <ListItemAvatar>
                  <Avatar  alt={item.tbl}  sx={{bgcolor:`${me[item.tbl].col}`,textTransform: 'uppercase'}} >
                    {me[item.tbl].shc}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  // tbl,rid,hdl,tsh,tsv,rnk,stp
                  primary={`${this.formatDate(item.stp)}... ${item.tbl}, ${item.hdl}`} 
                  secondary={`${item.tsh}`} 
                  //secondary={`${this.formatDate(item.dcd)}, ${item.rfn}, ${item.tri}`}
                  />
                {/* <ListItemSecondaryAction>
                  <IconButton aria-label="View" onClick={()=>{this.onPreview(item)}}>
                    <MoreVertIcon color="action" />
                  </IconButton>
                </ListItemSecondaryAction> */}
                </ListItemButton>
              </ListItem>
              {(idx<data.length-1)&&<Divider variant="inset" />}
            </Box>
          )}
        </List>
        </Box>
        : <Box sx={{...s.nodata}}>No data to show</Box>}
      </Paper>
    );
  }
}

SearchResult.propTypes = {
  data: PropTypes.array
};

export default SearchResult;
